// const API_URL =
//     document.domain === 'localhost'
//     ? "http://localhost:4500"
//     : "production";
const API_URL = "https://hquswoext6.execute-api.ap-south-1.amazonaws.com/prod";

const Apis = {
  //Authentication api
  GetUserLogin: `${API_URL}/user/login`,
  GetUserRegsiter: `${API_URL}/user/create`,
  GetAllUserList: `${API_URL}/user`,

  //client api
  GetClientLogin: `${API_URL}/client/login`,
  GetClientRegsiter: `${API_URL}/client/create`,
  GetAllClientList: `${API_URL}/client`,
  GetClientUpdate: `${API_URL}/client/update`,
  GetDeleteClientList: `${API_URL}/client/delete`,

  //User api
  GetUserLogin: `${API_URL}/user/login`,
  GetUserRegsiter: `${API_URL}/user/create`,
  GetAllUserList: `${API_URL}/user`,
  GetUserUpdate: `${API_URL}/user`,
  GetDeleteUserList: `${API_URL}/user`,

  //category api
  GetAllCategoryPath: `${API_URL}/categories`,

  //Journal api
  GetAllJournalPath: `${API_URL}/journal`,

  // article API
  GetAllArticlePath: `${API_URL}/articles`,

  //Notificationpath
  GetAllNotificationPath: `${API_URL}/notification`,
  markAsRead: `${API_URL}/markNotificationAsSeen`,

  // Chat API Path
  GetAllChatPath: `${API_URL}/chats`,

  // paymentChat API Path
  GetAllPaymentChatPath: `${API_URL}/paymentChat`,

  // fileview URL
  GetFileViewPath: `${API_URL}/file-view`,

  // services
  GetAllServices: `${API_URL}/services`,

  //manualjournal
  GetAllManualJournal: `${API_URL}/dealwithjournal`,

  //payment modes
  GetAllPaymentModes: `${API_URL}/paymentmodes`,


  //bank name
  GetAllBanks: `${API_URL}/bankname`,

};
export { API_URL, Apis };
